export const REFRESH_INTERVAL = 60 * 1000 * 5; // 5 minutes
export const NOTES_MAX_LENGTH = 2000; // Character limit for notes fields (monitoring points, assets, assemblies)
export const THIRTY_SECONDS_MS = 30 * 1000;
export const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;
export const ONE_MINUTE_MS = 60 * 1000;
export const ONE_DAY_IN_SECONDS = 24 * 60 * 60;
export const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
